import { jsx as We, jsxs as Kt } from "react/jsx-runtime";
import Ce, { createContext as Co, useState as B, useRef as le, useEffect as R, useContext as Ro, useLayoutEffect as To, useCallback as Lo, useImperativeHandle as ko } from "react";
import { I as No } from "./ic_close-C57k_mIW.mjs";
import { c as Xt } from "./tw-cn-mXgPecoF.mjs";
import { I as Do } from "./icon-button-CBGiAhhG.mjs";
import { c as ao } from "./variance-DhhqoHkK.mjs";
const qe = Math.min, Re = Math.max, yt = Math.round, vt = Math.floor, de = (e) => ({
  x: e,
  y: e
}), Po = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Bo = {
  start: "end",
  end: "start"
};
function kt(e, t, n) {
  return Re(e, qe(t, n));
}
function st(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Te(e) {
  return e.split("-")[0];
}
function it(e) {
  return e.split("-")[1];
}
function uo(e) {
  return e === "x" ? "y" : "x";
}
function zt(e) {
  return e === "y" ? "height" : "width";
}
const zo = /* @__PURE__ */ new Set(["top", "bottom"]);
function be(e) {
  return zo.has(Te(e)) ? "y" : "x";
}
function $t(e) {
  return uo(be(e));
}
function $o(e, t, n) {
  n === void 0 && (n = !1);
  const o = it(e), l = $t(e), r = zt(l);
  let s = l === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[r] > t.floating[r] && (s = wt(s)), [s, wt(s)];
}
function Io(e) {
  const t = wt(e);
  return [Nt(e), t, Nt(t)];
}
function Nt(e) {
  return e.replace(/start|end/g, (t) => Bo[t]);
}
const Yt = ["left", "right"], Ut = ["right", "left"], Mo = ["top", "bottom"], jo = ["bottom", "top"];
function Fo(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Ut : Yt : t ? Yt : Ut;
    case "left":
    case "right":
      return t ? Mo : jo;
    default:
      return [];
  }
}
function Wo(e, t, n, o) {
  const l = it(e);
  let r = Fo(Te(e), n === "start", o);
  return l && (r = r.map((s) => s + "-" + l), t && (r = r.concat(r.map(Nt)))), r;
}
function wt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Po[t]);
}
function Vo(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function fo(e) {
  return typeof e != "number" ? Vo(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function gt(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: l
  } = e;
  return {
    width: o,
    height: l,
    top: n,
    left: t,
    right: t + o,
    bottom: n + l,
    x: t,
    y: n
  };
}
function Jt(e, t, n) {
  let {
    reference: o,
    floating: l
  } = e;
  const r = be(t), s = $t(t), i = zt(s), c = Te(t), a = r === "y", p = o.x + o.width / 2 - l.width / 2, f = o.y + o.height / 2 - l.height / 2, v = o[i] / 2 - l[i] / 2;
  let u;
  switch (c) {
    case "top":
      u = {
        x: p,
        y: o.y - l.height
      };
      break;
    case "bottom":
      u = {
        x: p,
        y: o.y + o.height
      };
      break;
    case "right":
      u = {
        x: o.x + o.width,
        y: f
      };
      break;
    case "left":
      u = {
        x: o.x - l.width,
        y: f
      };
      break;
    default:
      u = {
        x: o.x,
        y: o.y
      };
  }
  switch (it(t)) {
    case "start":
      u[s] -= v * (n && a ? -1 : 1);
      break;
    case "end":
      u[s] += v * (n && a ? -1 : 1);
      break;
  }
  return u;
}
const Ho = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: l = "absolute",
    middleware: r = [],
    platform: s
  } = n, i = r.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let a = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: l
  }), {
    x: p,
    y: f
  } = Jt(a, o, c), v = o, u = {}, m = 0;
  for (let h = 0; h < i.length; h++) {
    const {
      name: x,
      fn: g
    } = i[h], {
      x: _,
      y: S,
      data: T,
      reset: O
    } = await g({
      x: p,
      y: f,
      initialPlacement: o,
      placement: v,
      strategy: l,
      middlewareData: u,
      rects: a,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    p = _ ?? p, f = S ?? f, u = {
      ...u,
      [x]: {
        ...u[x],
        ...T
      }
    }, O && m <= 50 && (m++, typeof O == "object" && (O.placement && (v = O.placement), O.rects && (a = O.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: l
    }) : O.rects), {
      x: p,
      y: f
    } = Jt(a, v, c)), h = -1);
  }
  return {
    x: p,
    y: f,
    placement: v,
    strategy: l,
    middlewareData: u
  };
};
async function po(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: l,
    platform: r,
    rects: s,
    elements: i,
    strategy: c
  } = e, {
    boundary: a = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: f = "floating",
    altBoundary: v = !1,
    padding: u = 0
  } = st(t, e), m = fo(u), x = i[v ? f === "floating" ? "reference" : "floating" : f], g = gt(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(x))) == null || n ? x : x.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(i.floating)),
    boundary: a,
    rootBoundary: p,
    strategy: c
  })), _ = f === "floating" ? {
    x: o,
    y: l,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, S = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(i.floating)), T = await (r.isElement == null ? void 0 : r.isElement(S)) ? await (r.getScale == null ? void 0 : r.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, O = gt(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: _,
    offsetParent: S,
    strategy: c
  }) : _);
  return {
    top: (g.top - O.top + m.top) / T.y,
    bottom: (O.bottom - g.bottom + m.bottom) / T.y,
    left: (g.left - O.left + m.left) / T.x,
    right: (O.right - g.right + m.right) / T.x
  };
}
const qo = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: l,
      rects: r,
      platform: s,
      elements: i,
      middlewareData: c
    } = t, {
      element: a,
      padding: p = 0
    } = st(e, t) || {};
    if (a == null)
      return {};
    const f = fo(p), v = {
      x: n,
      y: o
    }, u = $t(l), m = zt(u), h = await s.getDimensions(a), x = u === "y", g = x ? "top" : "left", _ = x ? "bottom" : "right", S = x ? "clientHeight" : "clientWidth", T = r.reference[m] + r.reference[u] - v[u] - r.floating[m], O = v[u] - r.reference[u], j = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a));
    let L = j ? j[S] : 0;
    (!L || !await (s.isElement == null ? void 0 : s.isElement(j))) && (L = i.floating[S] || r.floating[m]);
    const Z = T / 2 - O / 2, X = L / 2 - h[m] / 2 - 1, Y = qe(f[g], X), ce = qe(f[_], X), G = Y, ae = L - h[m] - ce, C = L / 2 - h[m] / 2 + Z, K = kt(G, C, ae), W = !c.arrow && it(l) != null && C !== K && r.reference[m] / 2 - (C < G ? Y : ce) - h[m] / 2 < 0, z = W ? C < G ? C - G : C - ae : 0;
    return {
      [u]: v[u] + z,
      data: {
        [u]: K,
        centerOffset: C - K - z,
        ...W && {
          alignmentOffset: z
        }
      },
      reset: W
    };
  }
}), Ko = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: l,
        middlewareData: r,
        rects: s,
        initialPlacement: i,
        platform: c,
        elements: a
      } = t, {
        mainAxis: p = !0,
        crossAxis: f = !0,
        fallbackPlacements: v,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: h = !0,
        ...x
      } = st(e, t);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const g = Te(l), _ = be(i), S = Te(i) === i, T = await (c.isRTL == null ? void 0 : c.isRTL(a.floating)), O = v || (S || !h ? [wt(i)] : Io(i)), j = m !== "none";
      !v && j && O.push(...Wo(i, h, m, T));
      const L = [i, ...O], Z = await po(t, x), X = [];
      let Y = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (p && X.push(Z[g]), f) {
        const C = $o(l, s, T);
        X.push(Z[C[0]], Z[C[1]]);
      }
      if (Y = [...Y, {
        placement: l,
        overflows: X
      }], !X.every((C) => C <= 0)) {
        var ce, G;
        const C = (((ce = r.flip) == null ? void 0 : ce.index) || 0) + 1, K = L[C];
        if (K && (!(f === "alignment" ? _ !== be(K) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        Y.every((N) => be(N.placement) === _ ? N.overflows[0] > 0 : !0)))
          return {
            data: {
              index: C,
              overflows: Y
            },
            reset: {
              placement: K
            }
          };
        let W = (G = Y.filter((z) => z.overflows[0] <= 0).sort((z, N) => z.overflows[1] - N.overflows[1])[0]) == null ? void 0 : G.placement;
        if (!W)
          switch (u) {
            case "bestFit": {
              var ae;
              const z = (ae = Y.filter((N) => {
                if (j) {
                  const V = be(N.placement);
                  return V === _ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  V === "y";
                }
                return !0;
              }).map((N) => [N.placement, N.overflows.filter((V) => V > 0).reduce((V, he) => V + he, 0)]).sort((N, V) => N[1] - V[1])[0]) == null ? void 0 : ae[0];
              z && (W = z);
              break;
            }
            case "initialPlacement":
              W = i;
              break;
          }
        if (l !== W)
          return {
            reset: {
              placement: W
            }
          };
      }
      return {};
    }
  };
}, Xo = /* @__PURE__ */ new Set(["left", "top"]);
async function Yo(e, t) {
  const {
    placement: n,
    platform: o,
    elements: l
  } = e, r = await (o.isRTL == null ? void 0 : o.isRTL(l.floating)), s = Te(n), i = it(n), c = be(n) === "y", a = Xo.has(s) ? -1 : 1, p = r && c ? -1 : 1, f = st(t, e);
  let {
    mainAxis: v,
    crossAxis: u,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return i && typeof m == "number" && (u = i === "end" ? m * -1 : m), c ? {
    x: u * p,
    y: v * a
  } : {
    x: v * a,
    y: u * p
  };
}
const Uo = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: l,
        y: r,
        placement: s,
        middlewareData: i
      } = t, c = await Yo(t, e);
      return s === ((n = i.offset) == null ? void 0 : n.placement) && (o = i.arrow) != null && o.alignmentOffset ? {} : {
        x: l + c.x,
        y: r + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, Jo = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: l
      } = t, {
        mainAxis: r = !0,
        crossAxis: s = !1,
        limiter: i = {
          fn: (x) => {
            let {
              x: g,
              y: _
            } = x;
            return {
              x: g,
              y: _
            };
          }
        },
        ...c
      } = st(e, t), a = {
        x: n,
        y: o
      }, p = await po(t, c), f = be(Te(l)), v = uo(f);
      let u = a[v], m = a[f];
      if (r) {
        const x = v === "y" ? "top" : "left", g = v === "y" ? "bottom" : "right", _ = u + p[x], S = u - p[g];
        u = kt(_, u, S);
      }
      if (s) {
        const x = f === "y" ? "top" : "left", g = f === "y" ? "bottom" : "right", _ = m + p[x], S = m - p[g];
        m = kt(_, m, S);
      }
      const h = i.fn({
        ...t,
        [v]: u,
        [f]: m
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - o,
          enabled: {
            [v]: r,
            [f]: s
          }
        }
      };
    }
  };
};
function bt() {
  return typeof window < "u";
}
function Xe(e) {
  return mo(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Q(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function me(e) {
  var t;
  return (t = (mo(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function mo(e) {
  return bt() ? e instanceof Node || e instanceof Q(e).Node : !1;
}
function se(e) {
  return bt() ? e instanceof Element || e instanceof Q(e).Element : !1;
}
function pe(e) {
  return bt() ? e instanceof HTMLElement || e instanceof Q(e).HTMLElement : !1;
}
function Qt(e) {
  return !bt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Q(e).ShadowRoot;
}
const Qo = /* @__PURE__ */ new Set(["inline", "contents"]);
function ct(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: l
  } = ie(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !Qo.has(l);
}
const Zo = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Go(e) {
  return Zo.has(Xe(e));
}
const en = [":popover-open", ":modal"];
function xt(e) {
  return en.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const tn = ["transform", "translate", "scale", "rotate", "perspective"], on = ["transform", "translate", "scale", "rotate", "perspective", "filter"], nn = ["paint", "layout", "strict", "content"];
function It(e) {
  const t = Mt(), n = se(e) ? ie(e) : e;
  return tn.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || on.some((o) => (n.willChange || "").includes(o)) || nn.some((o) => (n.contain || "").includes(o));
}
function rn(e) {
  let t = xe(e);
  for (; pe(t) && !Ke(t); ) {
    if (It(t))
      return t;
    if (xt(t))
      return null;
    t = xe(t);
  }
  return null;
}
function Mt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const ln = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Ke(e) {
  return ln.has(Xe(e));
}
function ie(e) {
  return Q(e).getComputedStyle(e);
}
function _t(e) {
  return se(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function xe(e) {
  if (Xe(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Qt(e) && e.host || // Fallback.
    me(e)
  );
  return Qt(t) ? t.host : t;
}
function ho(e) {
  const t = xe(e);
  return Ke(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : pe(t) && ct(t) ? t : ho(t);
}
function lt(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const l = ho(e), r = l === ((o = e.ownerDocument) == null ? void 0 : o.body), s = Q(l);
  if (r) {
    const i = Dt(s);
    return t.concat(s, s.visualViewport || [], ct(l) ? l : [], i && n ? lt(i) : []);
  }
  return t.concat(l, lt(l, [], n));
}
function Dt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function vo(e) {
  const t = ie(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const l = pe(e), r = l ? e.offsetWidth : n, s = l ? e.offsetHeight : o, i = yt(n) !== r || yt(o) !== s;
  return i && (n = r, o = s), {
    width: n,
    height: o,
    $: i
  };
}
function jt(e) {
  return se(e) ? e : e.contextElement;
}
function He(e) {
  const t = jt(e);
  if (!pe(t))
    return de(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: l,
    $: r
  } = vo(t);
  let s = (r ? yt(n.width) : n.width) / o, i = (r ? yt(n.height) : n.height) / l;
  return (!s || !Number.isFinite(s)) && (s = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: s,
    y: i
  };
}
const sn = /* @__PURE__ */ de(0);
function yo(e) {
  const t = Q(e);
  return !Mt() || !t.visualViewport ? sn : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function cn(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Q(e) ? !1 : t;
}
function Le(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const l = e.getBoundingClientRect(), r = jt(e);
  let s = de(1);
  t && (o ? se(o) && (s = He(o)) : s = He(e));
  const i = cn(r, n, o) ? yo(r) : de(0);
  let c = (l.left + i.x) / s.x, a = (l.top + i.y) / s.y, p = l.width / s.x, f = l.height / s.y;
  if (r) {
    const v = Q(r), u = o && se(o) ? Q(o) : o;
    let m = v, h = Dt(m);
    for (; h && o && u !== m; ) {
      const x = He(h), g = h.getBoundingClientRect(), _ = ie(h), S = g.left + (h.clientLeft + parseFloat(_.paddingLeft)) * x.x, T = g.top + (h.clientTop + parseFloat(_.paddingTop)) * x.y;
      c *= x.x, a *= x.y, p *= x.x, f *= x.y, c += S, a += T, m = Q(h), h = Dt(m);
    }
  }
  return gt({
    width: p,
    height: f,
    x: c,
    y: a
  });
}
function St(e, t) {
  const n = _t(e).scrollLeft;
  return t ? t.left + n : Le(me(e)).left + n;
}
function wo(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - St(e, n), l = n.top + t.scrollTop;
  return {
    x: o,
    y: l
  };
}
function an(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: l
  } = e;
  const r = l === "fixed", s = me(o), i = t ? xt(t.floating) : !1;
  if (o === s || i && r)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = de(1);
  const p = de(0), f = pe(o);
  if ((f || !f && !r) && ((Xe(o) !== "body" || ct(s)) && (c = _t(o)), pe(o))) {
    const u = Le(o);
    a = He(o), p.x = u.x + o.clientLeft, p.y = u.y + o.clientTop;
  }
  const v = s && !f && !r ? wo(s, c) : de(0);
  return {
    width: n.width * a.x,
    height: n.height * a.y,
    x: n.x * a.x - c.scrollLeft * a.x + p.x + v.x,
    y: n.y * a.y - c.scrollTop * a.y + p.y + v.y
  };
}
function un(e) {
  return Array.from(e.getClientRects());
}
function fn(e) {
  const t = me(e), n = _t(e), o = e.ownerDocument.body, l = Re(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), r = Re(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + St(e);
  const i = -n.scrollTop;
  return ie(o).direction === "rtl" && (s += Re(t.clientWidth, o.clientWidth) - l), {
    width: l,
    height: r,
    x: s,
    y: i
  };
}
const Zt = 25;
function dn(e, t) {
  const n = Q(e), o = me(e), l = n.visualViewport;
  let r = o.clientWidth, s = o.clientHeight, i = 0, c = 0;
  if (l) {
    r = l.width, s = l.height;
    const p = Mt();
    (!p || p && t === "fixed") && (i = l.offsetLeft, c = l.offsetTop);
  }
  const a = St(o);
  if (a <= 0) {
    const p = o.ownerDocument, f = p.body, v = getComputedStyle(f), u = p.compatMode === "CSS1Compat" && parseFloat(v.marginLeft) + parseFloat(v.marginRight) || 0, m = Math.abs(o.clientWidth - f.clientWidth - u);
    m <= Zt && (r -= m);
  } else a <= Zt && (r += a);
  return {
    width: r,
    height: s,
    x: i,
    y: c
  };
}
const pn = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function mn(e, t) {
  const n = Le(e, !0, t === "fixed"), o = n.top + e.clientTop, l = n.left + e.clientLeft, r = pe(e) ? He(e) : de(1), s = e.clientWidth * r.x, i = e.clientHeight * r.y, c = l * r.x, a = o * r.y;
  return {
    width: s,
    height: i,
    x: c,
    y: a
  };
}
function Gt(e, t, n) {
  let o;
  if (t === "viewport")
    o = dn(e, n);
  else if (t === "document")
    o = fn(me(e));
  else if (se(t))
    o = mn(t, n);
  else {
    const l = yo(e);
    o = {
      x: t.x - l.x,
      y: t.y - l.y,
      width: t.width,
      height: t.height
    };
  }
  return gt(o);
}
function go(e, t) {
  const n = xe(e);
  return n === t || !se(n) || Ke(n) ? !1 : ie(n).position === "fixed" || go(n, t);
}
function hn(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = lt(e, [], !1).filter((i) => se(i) && Xe(i) !== "body"), l = null;
  const r = ie(e).position === "fixed";
  let s = r ? xe(e) : e;
  for (; se(s) && !Ke(s); ) {
    const i = ie(s), c = It(s);
    !c && i.position === "fixed" && (l = null), (r ? !c && !l : !c && i.position === "static" && !!l && pn.has(l.position) || ct(s) && !c && go(e, s)) ? o = o.filter((p) => p !== s) : l = i, s = xe(s);
  }
  return t.set(e, o), o;
}
function vn(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: l
  } = e;
  const s = [...n === "clippingAncestors" ? xt(t) ? [] : hn(t, this._c) : [].concat(n), o], i = s[0], c = s.reduce((a, p) => {
    const f = Gt(t, p, l);
    return a.top = Re(f.top, a.top), a.right = qe(f.right, a.right), a.bottom = qe(f.bottom, a.bottom), a.left = Re(f.left, a.left), a;
  }, Gt(t, i, l));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function yn(e) {
  const {
    width: t,
    height: n
  } = vo(e);
  return {
    width: t,
    height: n
  };
}
function wn(e, t, n) {
  const o = pe(t), l = me(t), r = n === "fixed", s = Le(e, !0, r, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = de(0);
  function a() {
    c.x = St(l);
  }
  if (o || !o && !r)
    if ((Xe(t) !== "body" || ct(l)) && (i = _t(t)), o) {
      const u = Le(t, !0, r, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else l && a();
  r && !o && l && a();
  const p = l && !o && !r ? wo(l, i) : de(0), f = s.left + i.scrollLeft - c.x - p.x, v = s.top + i.scrollTop - c.y - p.y;
  return {
    x: f,
    y: v,
    width: s.width,
    height: s.height
  };
}
function Tt(e) {
  return ie(e).position === "static";
}
function eo(e, t) {
  if (!pe(e) || ie(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return me(e) === n && (n = n.ownerDocument.body), n;
}
function bo(e, t) {
  const n = Q(e);
  if (xt(e))
    return n;
  if (!pe(e)) {
    let l = xe(e);
    for (; l && !Ke(l); ) {
      if (se(l) && !Tt(l))
        return l;
      l = xe(l);
    }
    return n;
  }
  let o = eo(e, t);
  for (; o && Go(o) && Tt(o); )
    o = eo(o, t);
  return o && Ke(o) && Tt(o) && !It(o) ? n : o || rn(e) || n;
}
const gn = async function(e) {
  const t = this.getOffsetParent || bo, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: wn(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function bn(e) {
  return ie(e).direction === "rtl";
}
const xn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: an,
  getDocumentElement: me,
  getClippingRect: vn,
  getOffsetParent: bo,
  getElementRects: gn,
  getClientRects: un,
  getDimensions: yn,
  getScale: He,
  isElement: se,
  isRTL: bn
};
function xo(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function _n(e, t) {
  let n = null, o;
  const l = me(e);
  function r() {
    var i;
    clearTimeout(o), (i = n) == null || i.disconnect(), n = null;
  }
  function s(i, c) {
    i === void 0 && (i = !1), c === void 0 && (c = 1), r();
    const a = e.getBoundingClientRect(), {
      left: p,
      top: f,
      width: v,
      height: u
    } = a;
    if (i || t(), !v || !u)
      return;
    const m = vt(f), h = vt(l.clientWidth - (p + v)), x = vt(l.clientHeight - (f + u)), g = vt(p), S = {
      rootMargin: -m + "px " + -h + "px " + -x + "px " + -g + "px",
      threshold: Re(0, qe(1, c)) || 1
    };
    let T = !0;
    function O(j) {
      const L = j[0].intersectionRatio;
      if (L !== c) {
        if (!T)
          return s();
        L ? s(!1, L) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      L === 1 && !xo(a, e.getBoundingClientRect()) && s(), T = !1;
    }
    try {
      n = new IntersectionObserver(O, {
        ...S,
        // Handle <iframe>s
        root: l.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(O, S);
    }
    n.observe(e);
  }
  return s(!0), r;
}
function Sn(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: l = !0,
    ancestorResize: r = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = o, a = jt(e), p = l || r ? [...a ? lt(a) : [], ...lt(t)] : [];
  p.forEach((g) => {
    l && g.addEventListener("scroll", n, {
      passive: !0
    }), r && g.addEventListener("resize", n);
  });
  const f = a && i ? _n(a, n) : null;
  let v = -1, u = null;
  s && (u = new ResizeObserver((g) => {
    let [_] = g;
    _ && _.target === a && u && (u.unobserve(t), cancelAnimationFrame(v), v = requestAnimationFrame(() => {
      var S;
      (S = u) == null || S.observe(t);
    })), n();
  }), a && !c && u.observe(a), u.observe(t));
  let m, h = c ? Le(e) : null;
  c && x();
  function x() {
    const g = Le(e);
    h && !xo(h, g) && n(), h = g, m = requestAnimationFrame(x);
  }
  return n(), () => {
    var g;
    p.forEach((_) => {
      l && _.removeEventListener("scroll", n), r && _.removeEventListener("resize", n);
    }), f == null || f(), (g = u) == null || g.disconnect(), u = null, c && cancelAnimationFrame(m);
  };
}
const An = Uo, En = Jo, On = Ko, Cn = qo, to = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), l = {
    platform: xn,
    ...n
  }, r = {
    ...l.platform,
    _c: o
  };
  return Ho(e, t, {
    ...l,
    platform: r
  });
};
function Rn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var _o = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = "", s = 0; s < arguments.length; s++) {
        var i = arguments[s];
        i && (r = l(r, o(i)));
      }
      return r;
    }
    function o(r) {
      if (typeof r == "string" || typeof r == "number")
        return r;
      if (typeof r != "object")
        return "";
      if (Array.isArray(r))
        return n.apply(null, r);
      if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
        return r.toString();
      var s = "";
      for (var i in r)
        t.call(r, i) && r[i] && (s = l(s, i));
      return s;
    }
    function l(r, s) {
      return s ? r ? r + " " + s : r + s : r;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(_o);
var Tn = _o.exports;
const Pt = /* @__PURE__ */ Rn(Tn);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const Ln = "react-tooltip-core-styles", kn = "react-tooltip-base-styles", oo = { core: !1, base: !1 };
function no({ css: e, id: t = kn, type: n = "base", ref: o }) {
  var l, r;
  if (!e || typeof document > "u" || oo[n] || n === "core" && typeof process < "u" && (!((l = process == null ? void 0 : process.env) === null || l === void 0) && l.REACT_TOOLTIP_DISABLE_CORE_STYLES) || n !== "base" && typeof process < "u" && (!((r = process == null ? void 0 : process.env) === null || r === void 0) && r.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  n === "core" && (t = Ln), o || (o = {});
  const { insertAt: s } = o;
  if (document.getElementById(t)) return;
  const i = document.head || document.getElementsByTagName("head")[0], c = document.createElement("style");
  c.id = t, c.type = "text/css", s === "top" && i.firstChild ? i.insertBefore(c, i.firstChild) : i.appendChild(c), c.styleSheet ? c.styleSheet.cssText = e : c.appendChild(document.createTextNode(e)), oo[n] = !0;
}
const ro = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: n = null, place: o = "top", offset: l = 10, strategy: r = "absolute", middlewares: s = [An(Number(l)), On({ fallbackAxisSideDirection: "start" }), En({ padding: 5 })], border: i, arrowSize: c = 8 }) => {
  if (!e) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: o };
  if (t === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: o };
  const a = s;
  return n ? (a.push(Cn({ element: n, padding: 5 })), to(e, t, { placement: o, strategy: r, middleware: a }).then(({ x: p, y: f, placement: v, middlewareData: u }) => {
    var m, h;
    const x = { left: `${p}px`, top: `${f}px`, border: i }, { x: g, y: _ } = (m = u.arrow) !== null && m !== void 0 ? m : { x: 0, y: 0 }, S = (h = { top: "bottom", right: "left", bottom: "top", left: "right" }[v.split("-")[0]]) !== null && h !== void 0 ? h : "bottom", T = i && { borderBottom: i, borderRight: i };
    let O = 0;
    if (i) {
      const j = `${i}`.match(/(\d+)px/);
      O = j != null && j[1] ? Number(j[1]) : 1;
    }
    return { tooltipStyles: x, tooltipArrowStyles: { left: g != null ? `${g}px` : "", top: _ != null ? `${_}px` : "", right: "", bottom: "", ...T, [S]: `-${c / 2 + O}px` }, place: v };
  })) : to(e, t, { placement: "bottom", strategy: r, middleware: a }).then(({ x: p, y: f, placement: v }) => ({ tooltipStyles: { left: `${p}px`, top: `${f}px` }, tooltipArrowStyles: {}, place: v }));
}, lo = (e, t) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), so = (e, t, n) => {
  let o = null;
  const l = function(...r) {
    const s = () => {
      o = null;
    };
    !o && (e.apply(this, r), o = setTimeout(s, t));
  };
  return l.cancel = () => {
    o && (clearTimeout(o), o = null);
  }, l;
}, io = (e) => e !== null && !Array.isArray(e) && typeof e == "object", Bt = (e, t) => {
  if (e === t) return !0;
  if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((l, r) => Bt(l, t[r]));
  if (Array.isArray(e) !== Array.isArray(t)) return !1;
  if (!io(e) || !io(t)) return e === t;
  const n = Object.keys(e), o = Object.keys(t);
  return n.length === o.length && n.every((l) => Bt(e[l], t[l]));
}, Nn = (e) => {
  if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
  const t = getComputedStyle(e);
  return ["overflow", "overflow-x", "overflow-y"].some((n) => {
    const o = t.getPropertyValue(n);
    return o === "auto" || o === "scroll";
  });
}, co = (e) => {
  if (!e) return null;
  let t = e.parentElement;
  for (; t; ) {
    if (Nn(t)) return t;
    t = t.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, Dn = typeof window < "u" ? To : R, oe = (e) => {
  e.current && (clearTimeout(e.current), e.current = null);
}, Pn = "DEFAULT_TOOLTIP_ID", Bn = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, zn = Co({ getTooltipData: () => Bn });
function So(e = Pn) {
  return Ro(zn).getTooltipData(e);
}
var Ve = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, Lt = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const $n = ({ forwardRef: e, id: t, className: n, classNameArrow: o, variant: l = "dark", anchorId: r, anchorSelect: s, place: i = "top", offset: c = 10, events: a = ["hover"], openOnClick: p = !1, positionStrategy: f = "absolute", middlewares: v, wrapper: u, delayShow: m = 0, delayHide: h = 0, float: x = !1, hidden: g = !1, noArrow: _ = !1, clickable: S = !1, closeOnEsc: T = !1, closeOnScroll: O = !1, closeOnResize: j = !1, openEvents: L, closeEvents: Z, globalCloseEvents: X, imperativeModeOnly: Y, style: ce, position: G, afterShow: ae, afterHide: C, disableTooltip: K, content: W, contentWrapperRef: z, isOpen: N, defaultIsOpen: V = !1, setIsOpen: he, activeAnchor: $, setActiveAnchor: ke, border: at, opacity: ut, arrowColor: ft, arrowSize: Ne = 8, role: At = "tooltip" }) => {
  var Ye;
  const H = le(null), De = le(null), ne = le(null), ye = le(null), Ue = le(null), [we, Et] = B({ tooltipStyles: {}, tooltipArrowStyles: {}, place: i }), [U, dt] = B(!1), [_e, Se] = B(!1), [D, Je] = B(null), Qe = le(!1), Ze = le(null), { anchorRefs: Ge, setActiveAnchor: pt } = So(t), Pe = le(!1), [ge, et] = B([]), Ae = le(!1), Be = p || a.includes("click"), Ot = Be || (L == null ? void 0 : L.click) || (L == null ? void 0 : L.dblclick) || (L == null ? void 0 : L.mousedown), ze = L ? { ...L } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !L && Be && Object.assign(ze, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const Ee = Z ? { ...Z } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !Z && Be && Object.assign(Ee, { mouseleave: !1, blur: !1, mouseout: !1 });
  const re = X ? { ...X } : { escape: T || !1, scroll: O || !1, resize: j || !1, clickOutsideAnchor: Ot || !1 };
  Y && (Object.assign(ze, { mouseover: !1, focus: !1, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(Ee, { mouseout: !1, blur: !1, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(re, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), Dn(() => (Ae.current = !0, () => {
    Ae.current = !1;
  }), []);
  const P = (d) => {
    Ae.current && (d && Se(!0), setTimeout(() => {
      Ae.current && (he == null || he(d), N === void 0 && dt(d));
    }, 10));
  };
  R(() => {
    if (N === void 0) return () => null;
    N && Se(!0);
    const d = setTimeout(() => {
      dt(N);
    }, 10);
    return () => {
      clearTimeout(d);
    };
  }, [N]), R(() => {
    if (U !== Qe.current) if (oe(Ue), Qe.current = U, U) ae == null || ae();
    else {
      const d = ((w) => {
        const b = w.match(/^([\d.]+)(ms|s)$/);
        if (!b) return 0;
        const [, I, F] = b;
        return Number(I) * (F === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      Ue.current = setTimeout(() => {
        Se(!1), Je(null), C == null || C();
      }, d + 25);
    }
  }, [U]);
  const mt = (d) => {
    Et((w) => Bt(w, d) ? w : d);
  }, tt = (d = m) => {
    oe(ne), _e ? P(!0) : ne.current = setTimeout(() => {
      P(!0);
    }, d);
  }, $e = (d = h) => {
    oe(ye), ye.current = setTimeout(() => {
      Pe.current || P(!1);
    }, d);
  }, ot = (d) => {
    var w;
    if (!d) return;
    const b = (w = d.currentTarget) !== null && w !== void 0 ? w : d.target;
    if (!(b != null && b.isConnected)) return ke(null), void pt({ current: null });
    m ? tt() : P(!0), ke(b), pt({ current: b }), oe(ye);
  }, Ie = () => {
    S ? $e(h || 100) : h ? $e() : P(!1), oe(ne);
  }, Me = ({ x: d, y: w }) => {
    var b;
    const I = { getBoundingClientRect: () => ({ x: d, y: w, width: 0, height: 0, top: w, left: d, right: d, bottom: w }) };
    ro({ place: (b = D == null ? void 0 : D.place) !== null && b !== void 0 ? b : i, offset: c, elementReference: I, tooltipReference: H.current, tooltipArrowReference: De.current, strategy: f, middlewares: v, border: at, arrowSize: Ne }).then((F) => {
      mt(F);
    });
  }, je = (d) => {
    if (!d) return;
    const w = d, b = { x: w.clientX, y: w.clientY };
    Me(b), Ze.current = b;
  }, nt = (d) => {
    var w;
    if (!U) return;
    const b = d.target;
    b.isConnected && (!((w = H.current) === null || w === void 0) && w.contains(b) || [document.querySelector(`[id='${r}']`), ...ge].some((I) => I == null ? void 0 : I.contains(b)) || (P(!1), oe(ne)));
  }, ht = so(ot, 50), M = so(Ie, 50), ee = (d) => {
    M.cancel(), ht(d);
  }, y = () => {
    ht.cancel(), M();
  }, A = Lo(() => {
    var d, w;
    const b = (d = D == null ? void 0 : D.position) !== null && d !== void 0 ? d : G;
    b ? Me(b) : x ? Ze.current && Me(Ze.current) : $ != null && $.isConnected && ro({ place: (w = D == null ? void 0 : D.place) !== null && w !== void 0 ? w : i, offset: c, elementReference: $, tooltipReference: H.current, tooltipArrowReference: De.current, strategy: f, middlewares: v, border: at, arrowSize: Ne }).then((I) => {
      Ae.current && mt(I);
    });
  }, [U, $, W, ce, i, D == null ? void 0 : D.place, c, f, G, D == null ? void 0 : D.position, x, Ne]);
  R(() => {
    var d, w;
    const b = new Set(Ge);
    ge.forEach((E) => {
      K != null && K(E) || b.add({ current: E });
    });
    const I = document.querySelector(`[id='${r}']`);
    I && !(K != null && K(I)) && b.add({ current: I });
    const F = () => {
      P(!1);
    }, ue = co($), fe = co(H.current);
    re.scroll && (window.addEventListener("scroll", F), ue == null || ue.addEventListener("scroll", F), fe == null || fe.addEventListener("scroll", F));
    let q = null;
    re.resize ? window.addEventListener("resize", F) : $ && H.current && (q = Sn($, H.current, A, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const te = (E) => {
      E.key === "Escape" && P(!1);
    };
    re.escape && window.addEventListener("keydown", te), re.clickOutsideAnchor && window.addEventListener("click", nt);
    const k = [], Fe = (E) => !!(E != null && E.target && ($ != null && $.contains(E.target))), Ao = (E) => {
      U && Fe(E) || ot(E);
    }, Eo = (E) => {
      U && Fe(E) && Ie();
    }, Ft = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], Wt = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(ze).forEach(([E, ve]) => {
      ve && (Ft.includes(E) ? k.push({ event: E, listener: ee }) : Wt.includes(E) && k.push({ event: E, listener: Ao }));
    }), Object.entries(Ee).forEach(([E, ve]) => {
      ve && (Ft.includes(E) ? k.push({ event: E, listener: y }) : Wt.includes(E) && k.push({ event: E, listener: Eo }));
    }), x && k.push({ event: "pointermove", listener: je });
    const Vt = () => {
      Pe.current = !0;
    }, Ht = () => {
      Pe.current = !1, Ie();
    }, qt = S && (Ee.mouseout || Ee.mouseleave);
    return qt && ((d = H.current) === null || d === void 0 || d.addEventListener("mouseover", Vt), (w = H.current) === null || w === void 0 || w.addEventListener("mouseout", Ht)), k.forEach(({ event: E, listener: ve }) => {
      b.forEach((Ct) => {
        var rt;
        (rt = Ct.current) === null || rt === void 0 || rt.addEventListener(E, ve);
      });
    }), () => {
      var E, ve;
      re.scroll && (window.removeEventListener("scroll", F), ue == null || ue.removeEventListener("scroll", F), fe == null || fe.removeEventListener("scroll", F)), re.resize ? window.removeEventListener("resize", F) : q == null || q(), re.clickOutsideAnchor && window.removeEventListener("click", nt), re.escape && window.removeEventListener("keydown", te), qt && ((E = H.current) === null || E === void 0 || E.removeEventListener("mouseover", Vt), (ve = H.current) === null || ve === void 0 || ve.removeEventListener("mouseout", Ht)), k.forEach(({ event: Ct, listener: rt }) => {
        b.forEach((Oo) => {
          var Rt;
          (Rt = Oo.current) === null || Rt === void 0 || Rt.removeEventListener(Ct, rt);
        });
      });
    };
  }, [$, A, _e, Ge, ge, L, Z, X, Be, m, h]), R(() => {
    var d, w;
    let b = (w = (d = D == null ? void 0 : D.anchorSelect) !== null && d !== void 0 ? d : s) !== null && w !== void 0 ? w : "";
    !b && t && (b = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`);
    const I = new MutationObserver((F) => {
      const ue = [], fe = [];
      F.forEach((q) => {
        if (q.type === "attributes" && q.attributeName === "data-tooltip-id" && (q.target.getAttribute("data-tooltip-id") === t ? ue.push(q.target) : q.oldValue === t && fe.push(q.target)), q.type === "childList") {
          if ($) {
            const te = [...q.removedNodes].filter((k) => k.nodeType === 1);
            if (b) try {
              fe.push(...te.filter((k) => k.matches(b))), fe.push(...te.flatMap((k) => [...k.querySelectorAll(b)]));
            } catch {
            }
            te.some((k) => {
              var Fe;
              return !!(!((Fe = k == null ? void 0 : k.contains) === null || Fe === void 0) && Fe.call(k, $)) && (Se(!1), P(!1), ke(null), oe(ne), oe(ye), !0);
            });
          }
          if (b) try {
            const te = [...q.addedNodes].filter((k) => k.nodeType === 1);
            ue.push(...te.filter((k) => k.matches(b))), ue.push(...te.flatMap((k) => [...k.querySelectorAll(b)]));
          } catch {
          }
        }
      }), (ue.length || fe.length) && et((q) => [...q.filter((te) => !fe.includes(te)), ...ue]);
    });
    return I.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      I.disconnect();
    };
  }, [t, s, D == null ? void 0 : D.anchorSelect, $]), R(() => {
    A();
  }, [A]), R(() => {
    if (!(z != null && z.current)) return () => null;
    const d = new ResizeObserver(() => {
      setTimeout(() => A());
    });
    return d.observe(z.current), () => {
      d.disconnect();
    };
  }, [W, z == null ? void 0 : z.current]), R(() => {
    var d;
    const w = document.querySelector(`[id='${r}']`), b = [...ge, w];
    $ && b.includes($) || ke((d = ge[0]) !== null && d !== void 0 ? d : w);
  }, [r, ge, $]), R(() => (V && P(!0), () => {
    oe(ne), oe(ye);
  }), []), R(() => {
    var d;
    let w = (d = D == null ? void 0 : D.anchorSelect) !== null && d !== void 0 ? d : s;
    if (!w && t && (w = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), w) try {
      const b = Array.from(document.querySelectorAll(w));
      et(b);
    } catch {
      et([]);
    }
  }, [t, s, D == null ? void 0 : D.anchorSelect]), R(() => {
    ne.current && (oe(ne), tt(m));
  }, [m]);
  const J = (Ye = D == null ? void 0 : D.content) !== null && Ye !== void 0 ? Ye : W, Oe = U && Object.keys(we.tooltipStyles).length > 0;
  return ko(e, () => ({ open: (d) => {
    if (d != null && d.anchorSelect) try {
      document.querySelector(d.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${d.anchorSelect}" is not a valid CSS selector`);
    }
    Je(d ?? null), d != null && d.delay ? tt(d.delay) : P(!0);
  }, close: (d) => {
    d != null && d.delay ? $e(d.delay) : P(!1);
  }, activeAnchor: $, place: we.place, isOpen: !!(_e && !g && J && Oe) })), _e && !g && J ? Ce.createElement(u, { id: t, role: At, className: Pt("react-tooltip", Ve.tooltip, Lt.tooltip, Lt[l], n, `react-tooltip__place-${we.place}`, Ve[Oe ? "show" : "closing"], Oe ? "react-tooltip__show" : "react-tooltip__closing", f === "fixed" && Ve.fixed, S && Ve.clickable), onTransitionEnd: (d) => {
    oe(Ue), U || d.propertyName !== "opacity" || (Se(!1), Je(null), C == null || C());
  }, style: { ...ce, ...we.tooltipStyles, opacity: ut !== void 0 && Oe ? ut : void 0 }, ref: H }, J, Ce.createElement(u, { className: Pt("react-tooltip-arrow", Ve.arrow, Lt.arrow, o, _ && Ve.noArrow), style: { ...we.tooltipArrowStyles, background: ft ? `linear-gradient(to right bottom, transparent 50%, ${ft} 50%)` : void 0, "--rt-arrow-size": `${Ne}px` }, ref: De })) : null;
}, In = ({ content: e }) => Ce.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), Mn = Ce.forwardRef(({ id: e, anchorId: t, anchorSelect: n, content: o, html: l, render: r, className: s, classNameArrow: i, variant: c = "dark", place: a = "top", offset: p = 10, wrapper: f = "div", children: v = null, events: u = ["hover"], openOnClick: m = !1, positionStrategy: h = "absolute", middlewares: x, delayShow: g = 0, delayHide: _ = 0, float: S = !1, hidden: T = !1, noArrow: O = !1, clickable: j = !1, closeOnEsc: L = !1, closeOnScroll: Z = !1, closeOnResize: X = !1, openEvents: Y, closeEvents: ce, globalCloseEvents: G, imperativeModeOnly: ae = !1, style: C, position: K, isOpen: W, defaultIsOpen: z = !1, disableStyleInjection: N = !1, border: V, opacity: he, arrowColor: $, arrowSize: ke, setIsOpen: at, afterShow: ut, afterHide: ft, disableTooltip: Ne, role: At = "tooltip" }, Ye) => {
  const [H, De] = B(o), [ne, ye] = B(l), [Ue, we] = B(a), [Et, U] = B(c), [dt, _e] = B(p), [Se, D] = B(g), [Je, Qe] = B(_), [Ze, Ge] = B(S), [pt, Pe] = B(T), [ge, et] = B(f), [Ae, Be] = B(u), [Ot, ze] = B(h), [Ee, re] = B(null), [P, mt] = B(null), tt = le(N), { anchorRefs: $e, activeAnchor: ot } = So(e), Ie = (M) => M == null ? void 0 : M.getAttributeNames().reduce((ee, y) => {
    var A;
    return y.startsWith("data-tooltip-") && (ee[y.replace(/^data-tooltip-/, "")] = (A = M == null ? void 0 : M.getAttribute(y)) !== null && A !== void 0 ? A : null), ee;
  }, {}), Me = (M) => {
    const ee = { place: (y) => {
      var A;
      we((A = y) !== null && A !== void 0 ? A : a);
    }, content: (y) => {
      De(y ?? o);
    }, html: (y) => {
      ye(y ?? l);
    }, variant: (y) => {
      var A;
      U((A = y) !== null && A !== void 0 ? A : c);
    }, offset: (y) => {
      _e(y === null ? p : Number(y));
    }, wrapper: (y) => {
      var A;
      et((A = y) !== null && A !== void 0 ? A : f);
    }, events: (y) => {
      const A = y == null ? void 0 : y.split(" ");
      Be(A ?? u);
    }, "position-strategy": (y) => {
      var A;
      ze((A = y) !== null && A !== void 0 ? A : h);
    }, "delay-show": (y) => {
      D(y === null ? g : Number(y));
    }, "delay-hide": (y) => {
      Qe(y === null ? _ : Number(y));
    }, float: (y) => {
      Ge(y === null ? S : y === "true");
    }, hidden: (y) => {
      Pe(y === null ? T : y === "true");
    }, "class-name": (y) => {
      re(y);
    } };
    Object.values(ee).forEach((y) => y(null)), Object.entries(M).forEach(([y, A]) => {
      var J;
      (J = ee[y]) === null || J === void 0 || J.call(ee, A);
    });
  };
  R(() => {
    De(o);
  }, [o]), R(() => {
    ye(l);
  }, [l]), R(() => {
    we(a);
  }, [a]), R(() => {
    U(c);
  }, [c]), R(() => {
    _e(p);
  }, [p]), R(() => {
    D(g);
  }, [g]), R(() => {
    Qe(_);
  }, [_]), R(() => {
    Ge(S);
  }, [S]), R(() => {
    Pe(T);
  }, [T]), R(() => {
    ze(h);
  }, [h]), R(() => {
    tt.current !== N && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [N]), R(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: N === "core", disableBase: N } }));
  }, []), R(() => {
    var M;
    const ee = new Set($e);
    let y = n;
    if (!y && e && (y = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), y) try {
      document.querySelectorAll(y).forEach((w) => {
        ee.add({ current: w });
      });
    } catch {
      console.warn(`[react-tooltip] "${y}" is not a valid CSS selector`);
    }
    const A = document.querySelector(`[id='${t}']`);
    if (A && ee.add({ current: A }), !ee.size) return () => null;
    const J = (M = P ?? A) !== null && M !== void 0 ? M : ot.current, Oe = new MutationObserver((w) => {
      w.forEach((b) => {
        var I;
        if (!J || b.type !== "attributes" || !(!((I = b.attributeName) === null || I === void 0) && I.startsWith("data-tooltip-"))) return;
        const F = Ie(J);
        Me(F);
      });
    }), d = { attributes: !0, childList: !1, subtree: !1 };
    if (J) {
      const w = Ie(J);
      Me(w), Oe.observe(J, d);
    }
    return () => {
      Oe.disconnect();
    };
  }, [$e, ot, P, t, n]), R(() => {
    C != null && C.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), V && !lo("border", `${V}`) && console.warn(`[react-tooltip] "${V}" is not a valid \`border\`.`), C != null && C.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), he && !lo("opacity", `${he}`) && console.warn(`[react-tooltip] "${he}" is not a valid \`opacity\`.`);
  }, []);
  let je = v;
  const nt = le(null);
  if (r) {
    const M = r({ content: (P == null ? void 0 : P.getAttribute("data-tooltip-content")) || H || null, activeAnchor: P });
    je = M ? Ce.createElement("div", { ref: nt, className: "react-tooltip-content-wrapper" }, M) : null;
  } else H && (je = H);
  ne && (je = Ce.createElement(In, { content: ne }));
  const ht = { forwardRef: Ye, id: e, anchorId: t, anchorSelect: n, className: Pt(s, Ee), classNameArrow: i, content: je, contentWrapperRef: nt, place: Ue, variant: Et, offset: dt, wrapper: ge, events: Ae, openOnClick: m, positionStrategy: Ot, middlewares: x, delayShow: Se, delayHide: Je, float: Ze, hidden: pt, noArrow: O, clickable: j, closeOnEsc: L, closeOnScroll: Z, closeOnResize: X, openEvents: Y, closeEvents: ce, globalCloseEvents: G, imperativeModeOnly: ae, style: C, position: K, isOpen: W, defaultIsOpen: z, border: V, opacity: he, arrowColor: $, arrowSize: ke, setIsOpen: at, afterShow: ut, afterHide: ft, disableTooltip: Ne, activeAnchor: P, setActiveAnchor: (M) => mt(M), role: At };
  return Ce.createElement($n, { ...ht });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (e) => {
  e.detail.disableCore || no({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s;--rt-arrow-size:8px}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit;z-index:-1}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), e.detail.disableBase || no({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:var(--rt-arrow-size);height:var(--rt-arrow-size)}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const jn = ao(
  ["!pointer-events-auto min-w-100 max-w-[280px] !rounded-8 !p-0 !typography-body-12-regular-multiline"],
  {
    variants: {
      theme: {
        default: "!bg-fill-neutral-main !text-static-white",
        white: "!bg-static-white !text-text-neutral-main drop-shadow-2"
      }
    },
    defaultVariants: {
      theme: "default"
    }
  }
), Fn = ao(["pl-12 pt-10"], {
  variants: {
    showCloseButton: {
      true: "pr-0",
      false: "pr-12"
    },
    hasActionButton: {
      true: "pb-0",
      false: "pb-10"
    }
  },
  defaultVariants: {
    showCloseButton: !1,
    hasActionButton: !1
  }
}), Wn = (e) => {
  const {
    children: t,
    eventType: n = "click",
    showCloseButton: o = !1,
    theme: l = "default",
    actionButton: r,
    className: s,
    render: i,
    html: c,
    ...a
  } = e, [p, f] = B(a.isOpen);
  R(() => {
    f(a.isOpen);
  }, [a.isOpen]);
  const v = ({ content: u, activeAnchor: m }) => {
    let h;
    return c ? h = /* @__PURE__ */ We("span", { dangerouslySetInnerHTML: { __html: c } }) : i ? h = i({ content: u, activeAnchor: m }) : h = u ?? t, h == null || h === !1 || h === "" ? null : /* @__PURE__ */ Kt("div", { className: "flex items-start", children: [
      /* @__PURE__ */ Kt("div", { className: Fn({ showCloseButton: o, hasActionButton: !!r }), children: [
        h,
        r ? /* @__PURE__ */ We("div", { className: "flex", children: r }) : null
      ] }),
      o ? /* @__PURE__ */ We("div", { className: "pt-2", children: /* @__PURE__ */ We(
        Do,
        {
          "aria-label": "닫기",
          icon: /* @__PURE__ */ We(No, { className: "size-16 pc:size-16" }),
          onClick: () => {
            f(!1);
          },
          size: "small",
          theme: l === "white" ? "ghost" : "transparent"
        }
      ) }) : null
    ] });
  };
  return /* @__PURE__ */ We(
    Mn,
    {
      ...a,
      className: Xt(jn({ theme: l }), s),
      classNameArrow: Xt("!size-[8.5px]", e.classNameArrow),
      events: [n],
      globalCloseEvents: {
        clickOutsideAnchor: !o
      },
      isOpen: p,
      opacity: 1,
      render: v,
      setIsOpen: f
    }
  );
};
Wn.displayName = "NDS.Tooltip";
export {
  Wn as T
};
